import React from "react";
import { RouteObject } from "../../interfaces/navigation";

const Dealerships = React.lazy(() => import("../../containers/Dealerships/EntrypointContainer"));

export const dealershipsRoutes: RouteObject[] = [
    {
        path: "/concesionaria",
        component: <Dealerships />,
        title: "Concesionarios"
    },
    {
        path: "/concesionaria/:dealershipCode",
        component: <Dealerships />,
        title: "Concesionarios"
    },
    
];
